<div class="mtest-medical-test-download-icon"
     pTooltip="{{'SI_ASSOCIATED_DOCUMENTS' | translate}}"
     tooltipPosition="top">
  <si-selector-custom text="SI_ASSOCIATED_DOCUMENTS"
                      [values]="optionValues"
                      [hideOnEmpty]="hideOnEmpty"
                      (modelChange)="onSelectOption($event)">
  <button class="si-button_link-thick align-items-center">
    <i class="icosun-files_downloads"></i>
    <span *ngIf="showText" class="ml-1">{{'SI_ASSOCIATED_DOCUMENTS' | translate}}</span>
  </button>
  </si-selector-custom>
</div>
